"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSubscriptionLinkOptions = exports.HowToInsertLinkUrl = exports.LinkRelTypes = exports.LinkRelDefault = exports.TrackableLinkFields = exports.CacheableLinkFields = exports.CacheableLinkTypes = exports.i18nKey = exports.EMAIL_SUBSCRIPTION_NON_MEMBERSHIP_LINKS = exports.EMAIL_SUBSCRIPTION_MEMBERSHIP_LINKS = exports.EmailSubscriptionHublVariables = exports.ReadOnlyLinkTypes = exports.ExternalLinkTypes = exports.LinkTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _EmailSubscriptionLin;

var LinkTypes = {
  PAGE: 'page',
  EMAIL: 'email',
  URL: 'url',
  FILE: 'file',
  EMAIL_SUBSCRIPTION: 'email_subscription',
  MEETING: 'meeting',
  ANCHOR: 'anchor',
  NONE: 'no_link'
};
exports.LinkTypes = LinkTypes;
var ExternalLinkTypes = [LinkTypes.FILE, LinkTypes.MEETING];
exports.ExternalLinkTypes = ExternalLinkTypes;
var ReadOnlyLinkTypes = [LinkTypes.ANCHOR, LinkTypes.EMAIL, LinkTypes.FILE];
exports.ReadOnlyLinkTypes = ReadOnlyLinkTypes;
var EmailSubscriptionHublVariables = {
  UNSUBSCRIBE: 'unsubscribe_link',
  SUBSCRIPTION_CONFIRMATION: 'subscription_confirmation_url',
  UNSUBSCRIBE_ALL: 'unsubscribe_link_all',
  VIEW_AS_WEBPAGE: 'view_as_page_url',
  MEMBERSHIP_REGISTRATION_LINK: 'membership_registration_link',
  MEMBERSHIP_PASSWORD_SAVED_LINK: 'membership_password_saved_link',
  MEMBERSHIP_PASSWORD_RESET_LINK: 'membership_password_reset_link'
};
exports.EmailSubscriptionHublVariables = EmailSubscriptionHublVariables;
var EMAIL_SUBSCRIPTION_MEMBERSHIP_LINKS = [EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK];
exports.EMAIL_SUBSCRIPTION_MEMBERSHIP_LINKS = EMAIL_SUBSCRIPTION_MEMBERSHIP_LINKS;
var EMAIL_SUBSCRIPTION_NON_MEMBERSHIP_LINKS = [EmailSubscriptionHublVariables.UNSUBSCRIBE, EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION, EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL, EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE];
exports.EMAIL_SUBSCRIPTION_NON_MEMBERSHIP_LINKS = EMAIL_SUBSCRIPTION_NON_MEMBERSHIP_LINKS;

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

exports.i18nKey = i18nKey;
var CacheableLinkTypes = [LinkTypes.PAGE, LinkTypes.FILE, LinkTypes.MEETING];
exports.CacheableLinkTypes = CacheableLinkTypes;
var CacheableLinkFields = ['linkDisplayName', 'linkType', 'fileMeta'];
exports.CacheableLinkFields = CacheableLinkFields;
var TrackableLinkFields = ['noFollow', 'externalLink', 'linkType', 'isValidLink', 'relAttr'];
exports.TrackableLinkFields = TrackableLinkFields;
var LinkRelDefault = 'noopener';
exports.LinkRelDefault = LinkRelDefault;
var LinkRelTypes = {
  REGULAR: 'regular',
  NOFOLLOW: 'nofollow',
  SPONSORED: 'sponsored',
  UGC: 'ugc'
};
exports.LinkRelTypes = LinkRelTypes;
var HowToInsertLinkUrl = 'https://knowledge.hubspot.com/cos-pages-editor/how-do-i-insert-a-link-on-a-hubspot-page';
exports.HowToInsertLinkUrl = HowToInsertLinkUrl;
var EmailSubscriptionLinkOptions = (_EmailSubscriptionLin = {}, (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.UNSUBSCRIBE, {
  text: 'emailSystemLinks.unsubscribe',
  help: 'emailSystemLinks.unsubscribeHelpText',
  value: EmailSubscriptionHublVariables.UNSUBSCRIBE
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION, {
  text: 'emailSystemLinks.subscriptionConfirmation',
  help: 'emailSystemLinks.subscriptionConfirmationHelpText',
  value: EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK, {
  text: 'emailSystemLinks.membershipRegistration',
  help: 'emailSystemLinks.membershipRegistrationHelpText',
  value: EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK, {
  text: 'emailSystemLinks.membershipPasswordSaved',
  help: 'emailSystemLinks.membershipPasswordSavedHelpText',
  value: EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK, {
  text: 'emailSystemLinks.membershipPasswordReset',
  help: 'emailSystemLinks.membershipPasswordResetHelpText',
  value: EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL, {
  text: 'emailSystemLinks.unsubscribeAll',
  help: 'emailSystemLinks.unsubscribeAllHelpText',
  value: EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL
}), (0, _defineProperty2.default)(_EmailSubscriptionLin, EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE, {
  text: 'emailSystemLinks.viewAsWebpage',
  help: 'emailSystemLinks.viewAsWebpageHelpText',
  value: EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE
}), _EmailSubscriptionLin);
exports.EmailSubscriptionLinkOptions = EmailSubscriptionLinkOptions;